import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import './RegisterEmployee.css';
import logo from '../assets/logo.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import API_BASE_URL from "../config";

const RegisterEmployee = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    roles: [],
  });

  const [roles, setRoles] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);


  // 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token"); // or sessionStorage
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/roles/all`)
      .then((res) => res.json())
      .then((data) => setRoles(data.map(r => r.name)))
      .catch(() => setErrorMessage('Unable to load roles'));
  }, []);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/employees`)
      .then((res) => res.json())
      .then((data) => setEmployees(data))
      .catch(() => setErrorMessage('Unable to load employees'));
  }, []);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleNameChange = (e) => {
    const selectedId = e.target.value;
    const selectedEmployee = employees.find(emp => emp.id.toString() === selectedId);
    if (selectedEmployee) {
      setFormData({
        ...formData,
        name: `${selectedEmployee.firstName} ${selectedEmployee.lastName}`,
        email: selectedEmployee.email,
      });
    }
  };

  const toggleRole = (role) => {
    setFormData(prev => ({
      ...prev,
      roles: prev.roles.includes(role) ? prev.roles.filter(r => r !== role) : [...prev.roles, role],
    }));
  };

  const generatePassword = () => {
    const length = 10;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let randomPassword = "";
    for (let i = 0; i < length; i++) randomPassword += charset[Math.floor(Math.random() * charset.length)];
    setFormData({ ...formData, password: randomPassword });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password || formData.roles.length === 0) {
      setErrorMessage('Please fill all fields.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) alert('Registration successful!');
      else setErrorMessage(data.message || 'Registration failed.');
    } catch {
      setErrorMessage('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-card">
        <img src={logo} alt="Logo" className="logo"/>
        <h2>Create User Account</h2>

        {errorMessage && <p className="error-msg">{errorMessage}</p>}

        <form onSubmit={handleSubmit} className="register-form">
          <label>Select Employee</label>
          <select
            name="name"
            value={employees.find(emp => `${emp.firstName} ${emp.lastName}` === formData.name)?.id || ''}
            onChange={handleNameChange}
            required
          >
            <option value="">Select Employee</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.firstName} {emp.lastName}</option>
            ))}
          </select>

          <label>Email</label>
          <input type="email" name="email" value={formData.email} readOnly required/>

          <label>Password</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {/* <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span> */}
            <button type="button" className="generate-btn" onClick={generatePassword}>Generate</button>
          </div>

          <div className="roles-section">
            <label>Select Roles</label>
            <div className="roles-list">
              {roles.filter(r => r !== "Admin").map((role, idx) => (
                <label key={idx} className="role-item">
                  <input type="checkbox" value={role} checked={formData.roles.includes(role)} onChange={() => toggleRole(role)}/>
                  {role}
                </label>
              ))}
            </div>
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterEmployee;
